"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.IceMoonColony = void 0;
var Tags_1 = require("../Tags");
var CardType_1 = require("../CardType");
var CardName_1 = require("../../CardName");
var BuildColony_1 = require("../../deferredActions/BuildColony");
var PlaceOceanTile_1 = require("../../deferredActions/PlaceOceanTile");
var Card_1 = require("../Card");
var CardRenderer_1 = require("../render/CardRenderer");
var IceMoonColony = (function (_super) {
    __extends(IceMoonColony, _super);
    function IceMoonColony() {
        return _super.call(this, {
            cost: 23,
            tags: [Tags_1.Tags.SPACE],
            name: CardName_1.CardName.ICE_MOON_COLONY,
            cardType: CardType_1.CardType.AUTOMATED,
            tr: { oceans: 1 },
            metadata: {
                cardNumber: 'C15',
                renderData: CardRenderer_1.CardRenderer.builder(function (b) { return b.colonies(1).oceans(1); }),
                description: 'Place 1 colony and 1 ocean tile.',
            },
        }) || this;
    }
    IceMoonColony.prototype.canPlay = function (player) {
        return player.hasAvailableColonyTileToBuildOn();
    };
    IceMoonColony.prototype.play = function (player) {
        player.game.defer(new BuildColony_1.BuildColony(player, false, 'Select colony for Ice Moon Colony'));
        player.game.defer(new PlaceOceanTile_1.PlaceOceanTile(player, 'Select ocean for Ice Moon Colony'));
        return undefined;
    };
    return IceMoonColony;
}(Card_1.Card));
exports.IceMoonColony = IceMoonColony;
